import React from "react";
import { Link } from "gatsby";
import ChatIcon from '@mui/icons-material/Chat';
import { logEvent } from "../analytics";

const ChatPromoBanner = ({ source = 'unknown' }) => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '10px',
      padding: '16px 24px',
      color: 'white',
      boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '16px'
    }}>
      <div style={{ flex: '1', minWidth: '250px' }}>
        <h3 style={{ 
          margin: '0 0 4px 0', 
          fontSize: '1.15rem', 
          fontWeight: '600',
          color: 'white'
        }}>
          Try AI Options Chat
        </h3>
        <p style={{ 
          margin: 0, 
          fontSize: '0.95rem', 
          opacity: 0.95,
          lineHeight: '1.4'
        }}>
          Get instant answers about options strategies, max pain calculations, and market positioning
        </p>
      </div>
      <Link 
        to="/chat/" 
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '10px 24px',
          background: 'white',
          color: '#667eea',
          borderRadius: '7px',
          fontWeight: '600',
          fontSize: '1rem',
          textDecoration: 'none',
          transition: 'all 0.3s ease',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          whiteSpace: 'nowrap'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.25)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        }}
        onClick={() => logEvent('chat_promo_click', { source })}
      >
        <ChatIcon style={{ fontSize: 20 }} />
        Try It Now
      </Link>
    </div>
  );
};

export default ChatPromoBanner;

